// Codes that mean *we* misconfigured or misused the SDK rather than that a
// payment was refused. They are useless to the user — they go to logging, while
// everything else (declines, cancellations, expiries) must reach the failure UI.
const INTEGRATION_CODE_PATTERNS = [
  "integration",
  "component_already_mounted",
  "component_not_supported",
  "not_available",
  "invalid_configuration",
  "invalid_payment_session",
  "payment_session_invalid",
  "invalid_public_key",
  "unauthorized"
];

export function isCheckoutFlowIntegrationError(error) {
  const code = String(error?.code || error?.type || "").toLowerCase();
  const message = String(error?.message || "").toLowerCase();

  // The SDK tags its own integration errors with a literal "[Integration]:"
  // prefix on the message — verified against a live SDK rejecting a malformed
  // payment session. Matched on the bracketed form only: a decline message is
  // free text and could otherwise trip a bare word like "unauthorized".
  return message.indexOf("[integration]") !== -1 || INTEGRATION_CODE_PATTERNS.some((p) => code.indexOf(p) !== -1);
}
